export default class LeaderBoard {
  count: number | 0
  top: Array<{
    id: number;
    avatar_thumb_url: string;
    name: string;
    points: number;
    score: number;
    username: string;
    rank: number;
  }>
  around: Array<{
    id: number;
    avatar_thumb_url: string;
    name: string;
    points: number;
    score: number;
    username: string;
    rank: number;
  }>
  member: {
    id: number;
    avatar_thumb_url: string;
    name: string;
    points: number;
    score: number;
    username: string;
    rank: number;
  }

  Type: string
  ClubID: number
  // tslint:disable-next-line:member-ordering
  static TOTAL = 'total'

  constructor (attributes = null) {
    if (attributes) Object.assign(this, attributes)
  }
}
